module.exports = __webpack_public_path__ + "img/aznavour-2026.cb7c6e05.jpg";